'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './quickbooks-list.routes';

export class QuickbooksListComponent {
  constructor(QuickbooksImportService, $stateParams, $window, PropertyService) {
    'ngInject';

    this.propertyId = $stateParams.propertyId;
    this.back = _ => $window.history.back();

    this.data = {};

    QuickbooksImportService.getByProperty({propertyId: this.propertyId}, data  => {
      data.forEach(entry => {
        if (!this.data[entry.account]) {
          this.data[entry.account] = [];
        }

        this.data[entry.account].push(entry);
      });

      this.accounts = Object.keys(this.data);
/* balance is now in the database because it doesn't always start with 0
      this.accounts.forEach(acc => {
        for (let i=0; i<this.data[acc].length; i++) {
          if (i===0) {
            this.data[acc][i].balance = this.data[acc][i].amount
          } else {
            this.data[acc][i].balance = this.data[acc][i-1].balance + this.data[acc][i].amount;
          }
        }
      });
*/
    }, err => {
      console.log(err);
    });

    PropertyService.get({id: this.propertyId}, property => this.name = "Lot# " + property.lotNo);

    QuickbooksImportService.getBalance({propertyId: this.propertyId}, data => {
      this.balances = data;
    });

  }
}

export default angular.module('conduu.quickbooksList', [uiRouter])
  .config(routes)
  .component('quickbooksList', {
    template: require('./quickbooks-list.html'),
    controller: QuickbooksListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/import/quickbooks-list/quickbooks-list.component.js